import { render } from "./local-super-buy.vue?vue&type=template&id=6a575c28&scoped=true&ts=true"
import script from "./local-super-buy.vue?vue&type=script&lang=ts"
export * from "./local-super-buy.vue?vue&type=script&lang=ts"

import "./local-super-buy.vue?vue&type=style&index=0&id=6a575c28&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a575c28"]])

export default __exports__